import { Component } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";

import Navigation from "@/components/Navigation";
import Logo from "@/components/Logo";
import Input from "@/components/Input";
import CodeInput from "@/components/CodeInput";
import LinkButton from "@/components/LinkButton";
import Button from "@/components/Button";
import Log from "@/components/Log";

import { Observer } from "mobx-vue";
import SignUpStore from "@/store/SignUpStore";
import ErrorText from "@/components/ErrorText";
import Captcha from '@/components/Captcha'

@Observer
@Component
export default class SignUp extends tsx.Component<any> {
  constructor(props: any) {
    super(props);
  }

  state = SignUpStore;

  render() {
    return (
      <div class="card" style="height: 100vh">
        <Navigation title="注册" />
        <Logo />
        <Input
          error={this.state.inputError.type === "mobile"}
          change={(e: any) =>
            this.state.inputOnChange(e.target.value, "mobile")
          }
          value={this.state.signUpInfo.mobile}
          iconName="signIn"
          placeholder="请输入您的手机号"
        />
        <CodeInput
          error={this.state.inputError.type === "code"}
          click={() => this.state.getSMSCaptcha()}
          disable={this.state.codeButton.disable}
          codeButtonText={this.state.codeButton.text}
          change={(e: any) => this.state.inputOnChange(e.target.value, "code")}
          value={this.state.signUpInfo.code}
          placeholder="请输入验证码"
        />
          <Captcha success={this.state.successCaptcha} visible={this.state.captchaVisible} close={this.state.closeCaptcha} />

          <Input
          error={
            this.state.inputError.type === "password" ||
            this.state.inputError.type === "password2"
          }
          change={(e: any) =>
            this.state.inputOnChange(e.target.value, "password")
          }
          value={this.state.signUpInfo.password}
          iconName="passWord"
          type="password"
          placeholder="请输入您的密码"
        />
        <Input
          error={this.state.inputError.type === "password2"}
          change={(e: any) =>
            this.state.inputOnChange(e.target.value, "password2")
          }
          value={this.state.signUpInfo.password2}
          iconName="passWord"
          type="password"
          placeholder="请再次输入您的密码"
        />
        <ErrorText>{this.state.inputError.text}</ErrorText>
        <LinkButton click={this.state.routerPushSignIn}>
          已有账号？立即登录
        </LinkButton>
        <Log number="A002">
          <Button click={() => this.state.signUp()}>立即注册</Button>
        </Log>
      </div>
    );
  }
}
